import Vue from 'vue'
import Router from 'vue-router'
import auth from '@/router/auth'

Vue.use(Router)

function checkSession (to, from, next) {
  if (Vue.prototype.$session.exists()) {
    auth.check()
      .then(res => {
        if (res) {
          next()
        } else {
          next('/login')
        }
      })
  }
  else {
    next('/login')
  }
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      component: () => import(
        '@/pages/errors/404.vue'
      )
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import(`@/pages/Login.vue`),
      beforeEnter (to, from, next) {
        if (Vue.prototype.$session.exists()) {
          auth.check()
            .then(res => {
              if (res) {
                next('/home')
              } else {
                next()
              }
            })
        }
        else {
          next()
        }
      }
    },
    {
      path: '/',
      name: 'Root',
      redirect: {
        name: 'Home'
      },
      component: () => import(`@/pages/Root.vue`),
      children: [
        {
          path: '/home',
          name: 'Home',
          component: () => import(`@/pages/Home.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/usuarios',
          name: 'User',
          component: () => import(`@/pages/User.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/empresas',
          name: 'Company',
          component: () => import(`@/pages/Company.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/zonas',
          name: 'Zone',
          component: () => import(`@/pages/Zone.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/plantas',
          name: 'Plant',
          component: () => import(`@/pages/Plant.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/unidades',
          name: 'Unit',
          component: () => import(`@/pages/Unit.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/clientes',
          name: 'Client',
          component: () => import(`@/pages/Client.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/productos',
          name: 'Product',
          component: () => import(`@/pages/Product.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/proyectos',
          name: 'Project',
          component: () => import(`@/pages/Project.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/sitios',
          name: 'Site',
          component: () => import(`@/pages/Site.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/pedidos',
          name: 'Order',
          component: () => import(`@/pages/Order.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/preguntas',
          name: 'Inquiry',
          component: () => import(`@/pages/Inquiry.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/prototipo',
          name: 'Prototype',
          component: () => import(`@/pages/Prototype.vue`),
          beforeEnter: checkSession
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  next();
});

router.afterEach((to, from) => {
});

export default router
